// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fixes an issue with Webkit where map canvas loses zIndex order and draws above attribution controls
   https://github.com/Expensify/App/issues/27800
*/
.mapboxgl-ctrl-bottom-left {
  -webkit-transform: translate3d(0, 0, 1px);
  transform: translate3d(0, 0, 1px);
}

.mapboxgl-ctrl-bottom-right {
  -webkit-transform: translate3d(0, 0, 1px);
  transform: translate3d(0, 0, 1px);
}`, "",{"version":3,"sources":["webpack://./src/components/MapView/mapbox.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;AACnC","sourcesContent":["/* Fixes an issue with Webkit where map canvas loses zIndex order and draws above attribution controls\n   https://github.com/Expensify/App/issues/27800\n*/\n.mapboxgl-ctrl-bottom-left {\n  -webkit-transform: translate3d(0, 0, 1px);\n  transform: translate3d(0, 0, 1px);\n}\n\n.mapboxgl-ctrl-bottom-right {\n  -webkit-transform: translate3d(0, 0, 1px);\n  transform: translate3d(0, 0, 1px);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
